<template>
  <div
    v-if="visible"
    ref="background"
    class="dialog-background"
    @click="backgroundClick"
  >
    <div class="dialog">
      <div class="dialog__header">
        <h1 class="dialog__title">{{ title }}</h1>
        <button v-if="!noCancel" class="dialog__close" @click="$emit('cancel')">&times;</button>
      </div>
      <div class="dialog__body"><slot /> <span v-html="body" /></div>
      <div class="dialog__answers">
        <div v-for="answer in answers" 
             :key="answer.answer">
          <a 
            v-if="answer.label"
            href="#" @click="answered(answer.answer)">
            {{ answer.label }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    visible: { type: Boolean, default: true },
    title: { type: String, required: true },
    body: { type: String, default: "" },
    answers: { type: Array, required: true },
    primary: { type: String, default: null },
    noCancel: { type: Boolean, default: null }
  },
  methods: {
    answered(answer) {
      if (answer === "cancel") {
        this.cancel();
      } else {
        this.$emit("answer", answer);
      }
    },
    backgroundClick(e) {
      if (e.target === this.$refs.background) {
        this.cancel();
      }
    },
    cancel() {
      if (!this.noCancel) {
        this.$emit("cancel");
      }
    }
  }
};
</script>

<style lang="scss">
.dialog-background {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(#001, 0.4);
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  justify-content: center;
  align-items: center;
}
.dialog {
  background: white;
  width: 500px;
  max-width: 90vw;
  border-radius: 3px;
  box-shadow: 4px 4px 40px rgba(black, 0.4);

  &__header {
    height: 50px;
    border-bottom: 1px solid #e7e7e7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 30px;
    padding-right: 16px;
  }
  &__title {
    font-size: 16px;
    margin-top: 4px;
    padding: 0;
  }
  &__close {
    -webkit-appearance: none;
    padding: 0;
    margin: 0;
    border: 0;
    font-size: 30px;
    background: transparent;
    outline: none;
    font-weight: 600;
    cursor: pointer;
  }
  &__body {
    padding: 15px 30px 30px 30px;
    span,
    p {
      font-size: 15px;
    }
  }
  &__answers {
    height: 50px;
    padding-left: 30px;
    padding-right: 30px;
    background: white;
    display: grid;
    justify-content: end;
    grid-gap: 10px;
    align-items: center;
    grid-auto-flow: column;
  }
}
</style>
